
import {authConstants} from "../../action-constants/onboarding.constants"
// import {ReducerParams} from "../../../types"


let userLogged = localStorage.getItem('mami-Super-XAuth') || "{}";

let user = JSON.parse(userLogged);
const initialState = Object.keys(user).length>=1 ? { loggedIn: true, user } : {loggedIn: false};


export const loginReducer = (state = initialState, action:any)=>{
    // export const loginReducer = ({state = initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case authConstants.LOGIN_USER_PENDING:
            return {
                request_status: authConstants.LOGIN_USER_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case authConstants.LOGIN_USER_SUCCESS:
            return {
                request_status: authConstants.LOGIN_USER_SUCCESS,
                loggedIn: true,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.LOGIN_USER_FAILURE:
            return {
                request_status: authConstants.LOGIN_USER_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.LOGIN_USER_RESET:
            return {
                request_status: authConstants.LOGIN_USER_RESET,
                is_request_processing: false,
                request_data: {},
            };
        
        case authConstants.LOGOUT:
            return {
                // test:"dsdsds",
                // request_data: action,
                ...state
              };
            
        case authConstants.LOGOUT_USER_SUCCESS:
                return {
                  ...state
                };

        default:
            return { ...state }
    }
}

export const forgotPasswordReducer = (state=initialState, action:any)=>{
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case authConstants.FORGOT_PASSWORD_PENDING:
            return {
                request_status: authConstants.FORGOT_PASSWORD_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case authConstants.FORGOT_PASSWORD_SUCCESS:
            return {
                request_status: authConstants.FORGOT_PASSWORD_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.FORGOT_PASSWORD_FAILURE:
            return {
                request_status: authConstants.FORGOT_PASSWORD_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.FORGOT_PASSWORD_RESET:
            return {
                request_status: authConstants.FORGOT_PASSWORD_RESET,
                is_request_processing: false,
                request_data: {},
            };
        

        default:
            return {...state} 
    }
}


export const resetPasswordReducer = (state=[], action:any)=>{
    // export const forgotPasswordReducer = ({state=initialState, action}:ReducerParams)=>{
    switch (action.type) {
        case authConstants.COMPLETE_PASSWORD_RESET_PENDING:
            return {
                request_status: authConstants.COMPLETE_PASSWORD_RESET_PENDING,
                is_request_processing: true,
                request_data: action
            };
        case authConstants.COMPLETE_PASSWORD_RESET_SUCCESS:
            return {
                request_status: authConstants.COMPLETE_PASSWORD_RESET_SUCCESS,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.COMPLETE_PASSWORD_RESET_FAILURE:
            return {
                request_status: authConstants.COMPLETE_PASSWORD_RESET_FAILURE,
                is_request_processing: false,
                request_data: action
            };
        case authConstants.COMPLETE_PASSWORD_RESET_RESET:
            return {
                request_status: authConstants.COMPLETE_PASSWORD_RESET_RESET,
                is_request_processing: false,
                request_data: {},
            };
        

        default:
            return {...state} 
    }
}





